import { forwardRef } from '@chakra-ui/react';
import Text, { TextProps } from '../Text/Text';
import Tooltip, { TooltipProps } from '../Tooltip/Tooltip';
import Icon from '../Icon/Icon';

export interface LabelProps extends TextProps {
  tooltip?: Omit<TooltipProps, 'children'>;
}

const Label = forwardRef<LabelProps, 'label'>((props, ref) => {
  const { children, tooltip, ...rest } = props;
  return (
    <Text
      as="label"
      textStyle="comp/input/label"
      display="flex"
      alignItems="center"
      gap="4"
      marginBlockEnd="4"
      {...rest}
      ref={ref}
    >
      {children}
      {tooltip && (
        <Tooltip {...tooltip}>
          <Icon color="icon.tertiary" name="InfoCircle" size="16" />
        </Tooltip>
      )}
    </Text>
  );
});

export default Label;
